import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import RootView from '../views/RootView.vue'

Vue.use(VueRouter)

// 分割ルーティング設定
import adminRoutes from './adminRoutes'
import academyRoutes from './academyRoutes'
import teacherRoutes from './teacherRoutes'
import studentRoutes from './studentRoutes'
import temporaryUserRoutes from './temporaryUserRoutes'
import contentRoutes from './contentRoutes'
import errorRoutes from './errorRoutes'
import debugRoutes from './debugRoutes'

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: RootView,
  },
]

/**
 * 分割定義したルーティング設定の追加
 */
routes.push(...adminRoutes)
routes.push(...academyRoutes)
routes.push(...teacherRoutes)
routes.push(...studentRoutes)
routes.push(...temporaryUserRoutes)
routes.push(...contentRoutes)
routes.push(...errorRoutes)

/**
 * テスト用ページのルーティング設定 環境設定がtrueの場合のみアクセス可能
 */
if (process.env.VUE_APP_ENABLE_DEBUG_PAGE == 'true') {
  routes.push(...debugRoutes)
}

/**
 * エラー画面へのリダイレクト設定を追加(最後に行うことで優先度を下げる)
 */
routes.push({
  path: '*',
  redirect: '/error/404',
})

/**
 * router設定
 */
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

/**
 * 画面遷移前にcookieを更新する
 */
router.beforeResolve(async (to, from, next) => {
  // cookie有効期限を更新
  await Vue.prototype.$appCookies.updateCookieExpire()
  // 処理を継続する
  next()
})

export default router
